import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";

type Props = {};

const PostPickButton = (props: Props) => {
  const { onPostPickHandler } = useConveyorBoxHandlers();

  return (
    <Button
      content="Post pick"
      size="big"
      secondary
      aria-label="Post pick"
      icon="box"
      onClick={onPostPickHandler}
    />
  );
};

export default PostPickButton;
